<template>
  <!-- 客观题 -->
  <div @mouseleave="handleMouseLeave" @mouseenter="handleMouseEnter">
    <div class="objective-content topic-box" :data-th="msg.th">
      <!--<CustomEditBox v-if="!msg.resolveNum&&msg.isEdit" :msg="msg" />-->
      <div>
        <div class="topic-th" v-if="msg.hasTitle">
          <EditScoreBox
            :msg="msg"
            @myBlur="handlerBlur"
            :isPreview="isPreview"
          ></EditScoreBox>
        </div>
        <div v-else>
          <EditScoreBox
            :msg="msg"
            @myBlur="handlerBlur"
            :isPreview="isPreview"
          ></EditScoreBox>
        </div>
        <div class="topic-bd obj-cont" style="padding:0 0px 0 3px !important;padding-bottom: 10px !important;">
          <TopicEditBox
            v-if="showTopicEditorBox"
            position="top:5px"
            :is-dis="true"
            :msg="msg"
            ref="topicEditBoxRef"
          ></TopicEditBox>
          <div class="flex-box" v-html="html">
            <!--<div v-for="(html, index) in msg.htmlArray" class="obj-group" :key="'html' + index">
            <div
              v-for="(group, i) in html"
              v-html="group"
              class="group"
              :class="{ verticalTop: msg.diffLayout }"
              :key="'group' + i"
            ></div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomEditBox from "@/components/TopicMakeBox/CustomEditBox";
import cardOperate from "@/assets/js/utils/cardOperate";
import { TABS } from "@/subjects/constant";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";

export default {
  name: "objectiveContent",
  components: {
    // CustomEditBox
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  props: {
    msg: Object,
    isPreview: Boolean,
  },
  computed: {
    html: function () {
      return this.msg.innerHTML.replace(
        /<p class="row"><\/p>/g,
        '<p class="row">&nbsp;</p>'
      );
    },
  },
  data() {
    return {
      showTopicEditorBox: false,
      aZTab: TABS,
      editMsg: {
        types: 1,
        // topicIndex: this.msg.topicIndex,
        // topicInPageIndex: this.msg.topicInPageIndex,
        // pageIndex: this.msg.pageIndex
      },
    };
  },
  methods: {
    editBox() {
      console.log(this.msg, "bojectiveTopic");
      cardOperate.editPageData(Object.assign({}, this.msg, { edit: 1 }));
    },
    handleMouseLeave(e) {
        const timer = setTimeout(() => {
          this.showTopicEditorBox = this.$refs.topicEditBoxRef && this.$refs.topicEditBoxRef.popoverVisible;
          // this.showTopicEditorBox =
          // (e.toElement &&
          // e.toElement.className &&
          // $("." + e.toElement.className.split(" ")[0]).closest(".el-popover")
          //   .length > 0) || this.$refs.topicEditBoxRef.popoverVisible;
          clearTimeout(timer);
        },200)
    },
  },
  mounted() {
    console.log(this.msg, "this.msg");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" >
.flex-box {
  display: flex;
  flex-wrap: wrap;
}
.object-item {
  display: flex;
  // min-height: 100px;
}
.objective-content {
  // pointer-events: none;
  .obj-cont {
    padding: 0 15px 20px !important;
    padding-bottom: 15px !important;
    .flex-box {
      pointer-events: none;
    }
  }
  .obj-group {
    // margin: 20px 10px 0 10px;
    margin: 10px 10px 0 10px;
    // height: 100px;
    .group {
      vertical-align: top;
    }
  }
  .group.verticalTop {
    display: inline-block;
    vertical-align: top; // 竖排时存在多选 上对齐
  }
  .gro-item {
    display: inline-block;
    // width: 24px;
    // height: 18px;
    width: 24px;
    // width: 22px;
    height: 15px;
    margin: 0 0px 3px 0;
    /*&:first-child {*/
    /*  min-width: 24px;*/
    /*  width: auto;*/
    /*}*/
  }
}
.topic-bd {
  padding-top: 0px !important;
  word-break: initial !important;
}
</style>
